import React from 'react';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import { BsArrowRight } from 'react-icons/bs';
import { Link } from 'react-scroll';
import GooglePlayImg from '../../assets/icons/googleplay-active.svg';
import AppStoreImg from '../../assets/icons/appstore-active.svg';
import './welcome.scss';

const Welcome = () => {
  return (
    <StyledWelcome>
      <Container className="d-flex flex-column">
        <StyledWelcomeInfo>
          <h4 className="welcome__subtitle">ENERGO. ЗАРЯЖАЙ НА ХОДУ</h4>
          <h1 className="welcome__title">
          Сервис проката пауэрбанков - пассивный бизнес с чистой прибылью от 200 000 рублей в месяц
          </h1>
          <Link to="contact-form">
            <WelcomeButton>
            Получить бизнес-план
              <Arrow />
            </WelcomeButton>
          </Link>
        </StyledWelcomeInfo>
        <StyleSocialButtons>
          <a href="https://apps.apple.com/ru/app/energo-%D0%B0%D1%80%D0%B5%D0%BD%D0%B4%D0%B0-%D0%BF%D0%B0%D0%B2%D0%B5%D1%80%D0%B1%D0%B0%D0%BD%D0%BA%D0%BE%D0%B2/id1507114521">
            <SocialImage src={AppStoreImg} alt="app-store" />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.energo.rnapp&hl=ru&gl=US">
            <SocialImage src={GooglePlayImg} alt="app-store" />
          </a>
        </StyleSocialButtons>
      </Container>
      <WelcomeStatistics>
        <Container>
          <WelcomeStatisticsBlock>
            <WelcomeStatisticsItem>
              <span className="statistics-title">1 000 000+</span>
              <span className="statistics-subtitle">
                Активных пользователей
              </span>
            </WelcomeStatisticsItem>
            <WelcomeStatisticsItem>
              <span className="statistics-title">3000+</span>
              <span className="statistics-subtitle">Зарядных станций</span>
            </WelcomeStatisticsItem>
            <WelcomeStatisticsItem>
              <span className="statistics-title">Без</span>
              <span className="statistics-subtitle">паушального взноса</span>
            </WelcomeStatisticsItem>
            <WelcomeStatisticsItem>
              <span className="statistics-title">от 17 месяцев</span>
              <span className="statistics-subtitle">Срок окупаемости</span>
            </WelcomeStatisticsItem>
          </WelcomeStatisticsBlock>
        </Container>
      </WelcomeStatistics>
    </StyledWelcome>
  );
};

const StyledWelcome = styled.section`
  margin-top: 94px;
`;

const StyledWelcomeInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 7.3rem;
  width: 75%;
  @media (max-width: 1135px) {
    width: 100%;
  }
  @media (max-width: 599px) {
    margin-top: 2.8rem;
  }
`;

const Arrow = styled(BsArrowRight)`
  margin-left: 15px;
  @media (max-width: 480px) {
    margin-left: 5px;
  }
`;

const WelcomeButton = styled.button`
  display: flex;
  align-items: center;
  background: #ffdc00;
  border: 2px solid #ffdc00;
  border-radius: 8px;
  padding: 20px 28px 20px 32px;
  color: #26292d;
  font-weight: 700;
  font-size: 20px;
  margin-top: 4rem;
  &:hover {
    background: #fff199;
    border: 2px solid #ffdc00;
  }
  @media (max-width: 1440px) {
    margin-top: 3rem;
  }
  @media (max-width: 1135px) {
    margin-top: 4rem;
  }
  @media (max-width: 600px) {
    width: 382px;
    font-size: 20px;
  }
  @media (max-width: 480px) {
    width: 100%;
    font-size: 20px;
    padding: 20px 11px 20px 11px;
    display: flex;
    justify-content: center;
  }
`;

export const StyleSocialButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 3rem;
  @media (max-width: 1440px) {
    margin-top: 4rem;
  }
`;

export const SocialImage = styled.img`
  width: 138.46px;
  margin-left: 8px;
  cursor: pointer;
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
`;

const WelcomeStatistics = styled.div`
  margin-top: 2.7rem;
  background: rgba(38, 41, 45, 0.5);
`;

const WelcomeStatisticsItem = styled.div`
  display: flex;
  flex-direction: column;
  border-left: 4px solid #ffdc00;
  width: 300px;
  padding: 2px 0;
  @media (max-width: 1440px) {
    width: 280px;
  }
  @media (max-width: 1135px) {
    width: 47.5%;
  }
  @media (max-width: 599px) {
    width: 45.5%;
  }
`;

const WelcomeStatisticsBlock = styled.div`
  display: flex;
  padding: 40px 0;
  justify-content: space-between;
  @media (max-width: 1135px) {
    flex-wrap: wrap;
    row-gap: 47px;
  }
  @media (max-width: 600px) {
    row-gap: 55px;
  }
`;

export default Welcome;
